module.exports = "<div id=\"histogram\" [ngClass]=\"{'noDataFound': noDataFound}\">\n\n  <div class=\"loadingWrapper\">\n    <div class=\"loadingBar\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/latitude-ui/timeslider/histogram/histogram.component.html
// module id = ./src/latitude-ui/timeslider/histogram/histogram.component.html
// module chunks = main